<script>
import Layout from "@/router/layouts/main";
import { api } from "@/state/services";
import Stat from "@/components/widgets/stat";

export default {
  locales: {
    pt: {
      Team: "Equipe",
      Username: "Usuário",
      Name: "Nome",
      Sponsor: "Patrocinadores",
      Status: "Status",
      Actions: "Ações",
      Access: "Acessar",
      "Total Affiliates": "Total de Afiliados",
      "We apologize, we are unable to retrieve information at this time. Please try again later.":
        "Pedimos desculpas, não podemos recuperar informações no momento. Por favor, tente novamente mais tarde.",
      "No records found.": "Nenhum registro encontrado.",
    },
    es: {
      Team: "Equipe",
      Username: "Nombre de Usuario",
      Name: "Nombre",
      Sponsor: "Patrocinadores",
      Status: "Status",
      Actions: "Acciones",
      Access: "Acceder",
      "Total Affiliates": "Total de Afiliados",
      "We apologize, we are unable to retrieve information at this time. Please try again later.":
        "Nos disculpamos, no podemos recuperar información en este momento. Por favor, inténtelo de nuevo más tarde.",
      "No records found.": "No se encontraron registros.",
    },
  },
  components: {
    Layout,
    Stat,
  },
  data() {
    return {
      id: this.$route.params.id || "",

      page: 1,
      pages: 0,
      table: {
        heade: [
          "Username",
          "Name",
          "Sponsor",
          "Status",
          "Actions",
        ],
        body: null,
      },

      statData: [
        { type: "line", icon: "bx bx-user", title: "Total Affiliates", value: "-" },
        { type: "line", icon: "bx bx-user", title: "Start", value: "-" },
        { type: "line", icon: "bx bx-user", title: "Bronze", value: "-" },
        { type: "line", icon: "bx bx-user", title: "Prata", value: "-" },
        { type: "line", icon: "bx bx-user", title: "Ouro", value: "-" },
        { type: "line", icon: "bx bx-user", title: "Diamante", value: "-" },
      ],

      cardUser: null,
      cardStatData: [],
    };
  },
  methods: {
    getStats() {
      api
        .get("network/team/status")
        .then((response) => {
          if (response.data.status == "success") {
            this.statData = this.buildStatData(response.data);
          }
        })
    },
    getCardStats(idUser) {
      api
        .get("network/team/status/" + idUser)
        .then((response) => {
          if (response.data.status == "success" && response.data.user) {
            this.cardUser = response.data.user;
            this.cardStatData = this.buildStatData(response.data);
          } else {
            this.cardUser = null;
            this.cardStatData = [];
          }
        })
    },
    buildStatData(data) {
      const arr = [
        { type: "line", icon: "bx bx-user", title: "Total Affiliates", value: data.total },
      ];
      data.plans.forEach((plan) => {
        arr.push({ type: "line", icon: "bx bx-user", title: plan.name, value: plan.total });
      });
      return arr;
    },
    getDirects() {
      this.table.body = null;

      api
        .get("network/team" + (this.id ? "/" + this.id : "") + "?page=" + this.page)
        .then((response) => {
          if (response.data.status == "success") {
            this.table.body = response.data.list;
            this.pages = response.data.pages;
          } else {
            this.table.body = [];
          }
        })
        .catch(() => {
          this.table.body = [];
        })
    },
  },
  mounted() {
    this.getStats();
    this.getDirects();

    if (this.id) {
      this.getCardStats(this.id);
    }
  },
  watch: {
    "$route.params.id": function (v) {
      this.id = v || "";
      this.page = 1;
      this.getDirects();

      if (this.id) {
        this.getCardStats(this.id);
      } else {
        this.cardUser = null;
        this.cardStatData = [];
      }
    },
    page: function () {
      this.getDirects();
    },
  },
};
</script>

<template>
  <Layout>
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <router-link tag="a" to="/">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
            <path d="M5 22h14a2 2 0 0 0 2-2v-9a1 1 0 0 0-.29-.71l-8-8a1 1 0 0 0-1.41 0l-8 8A1 1 0 0 0 3 11v9a2 2 0 0 0 2 2zm5-2v-5h4v5zm-5-8.59 7-7 7 7V20h-3v-5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v5H5z">
            </path>
          </svg>
        </router-link>
      </li>
      <li class="breadcrumb-item">Rede</li>
    </ol>

    <div class="page-title-box d-md-flex justify-content-between">
      <div>
        <h3>{{ t('Team') }}</h3>
        <p></p>
      </div>
    </div>

    <div class="row">
      <div v-for="(stat, index) of statData" :key="index" class="col-6 col-md-2">
        <Stat :type="stat.type" :icon="stat.icon" :title="stat.title" :value="stat.value" />
      </div>
    </div>

    <div v-if="cardUser" class="card">
      <div class="card-body pb-0">
        <h5 class="mb-3">
          <small class="text-muted notranslate">{{ cardUser.username }}</small><br>
          {{ cardUser.name }}
        </h5>
        <div class="row mb-0">
          <div v-for="(stat, index) of cardStatData" :key="index" class="col-6 col-md-2">
            <Stat :type="stat.type" :icon="stat.icon" :title="stat.title" :value="stat.value" />
          </div>
        </div>
      </div>
    </div>

    <div v-if="!table.body" class="card">
      <div class="card-body min-vh-25 d-flex justify-content-center align-items-center">
        <b-spinner variant="default" role="status"></b-spinner>
      </div>
    </div>

    <div v-else-if="table.body && table.body.length == 0" class="card">
      <div class="card-body min-vh-25 d-flex justify-content-center align-items-center">
        <div class="text-center">
          <i class="far fa-sad-cry font-size-24"></i><br>
          nenhum registro encontrado
        </div>
      </div>
    </div>

    <div v-else class="card">
      <div class="card-body">
        <div class="table-responsive">
          <table class="table table-centered table-nowrap">
            <thead class="thead-light">
              <tr>
                <th v-for="th in table.heade" :key="th">{{ t(th) }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in table.body" :key="index">
                <td class="notranslate">{{ row.username }}</td>
                <td class="notranslate">{{ row.name }}</td>
                <td class="notranslate">{{ row.sponsor }}</td>
                <td>
                  <span v-if="row.status === 'inactive'" class="badge badge-soft-danger font-size-12">INATIVO</span>
                  <span v-else-if="row.status === 'active'" class="badge badge-soft-success font-size-12">ATIVO</span>
                </td>
                <td>
                  <router-link :to="'/network/team/' + row.id" class="btn btn-sm btn-primary">{{ t('Access') }}</router-link>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <paginate v-if="table.body && table.body.length > 0" v-model="page" :page-count="pages" :page-range="3" :margin-pages="2" prev-text="<i class='mdi mdi-chevron-left'></i>"
          next-text="<i class='mdi mdi-chevron-right'></i>" :container-class="'pagination pagination-rounded justify-content-center mt-4'" :page-class="'page-item'" :page-link-class="'page-link'"
          :prev-link-class="'page-link'" :next-link-class="'page-link'" :break-view-link-class="'page-link'">
        </paginate>
      </div>
    </div>
  </Layout>
</template>
